import { useCallback, useEffect, useState } from "react";

import { notification } from "antd";

import api from "../../../../../api";
import { IUser, IUserDetails } from "../../../../../types";
import UserTaxInformationBlock from "../../../../common/UserTaxInformationBlock";
import { UserDetailsBlock } from "../../styledComponents";

const UserDetails = ({ user: initialUser }: { user: IUser | null }) => {
  const [user, setUser] = useState<IUser | null>(initialUser);

  useEffect(() => {
    setUser(initialUser);
  }, [initialUser]);

  const editUser = useCallback(
    async (email: string, userDetails: IUserDetails) => {
      try {
        const updatedUser = await api.kontax.updateUser({
          email,
          ...userDetails,
        });
        setUser({ ...user, ...updatedUser });
      } catch (error) {
        notification.error({
          message: "Failed updating user.",
        });
      }
    },
    [user]
  );

  if (!user) return null;

  return (
    <UserDetailsBlock>
      <UserTaxInformationBlock user={user} editUser={editUser} />
    </UserDetailsBlock>
  );
};

export default UserDetails;
